import {httpRequest} from '@/api/http-request'
import apiInterface from '@/api/interface'
import data from '@/api/data'

// 获取数据列表
function getDataList(apiInterface, params, arr, filter, callback) {
  httpRequest(apiInterface, params).then(res => {
    if (res.code === 200) {
      params.totalPage = res.page.totalPage
      if (res.data.length && arr.length < res.page.totalRow) {
        arr.push(...res.data)
      }

      // 继续下一页查询
      ++params.pageNum
      if (params.pageNum <= res.page.totalPage && arr.length < res.page.totalRow) {
        setTimeout(() => getDataList(apiInterface, params, arr, filter, callback), 10)
      } else { // 查询完毕
        if (filter) { // 过滤处理
          filter(arr)
        }
        if (callback) { // 数据回调
          callback()
        }
      }
    } else {
      arr = []
    }
  })
}

// 清除全部数据
export function clearAllData() {
  data.regions = []
  data.encoders = []
  data.auxMonitoringDevices = []
  data.servers = []
  data.services = []
  data.maps = []
  data.mapNodeModels = []
  data.runSchedules = []
  data.projects = []
  data.departments = []
  data.persons = []
  data.users = []
  data.systemMenus = []
}

// 过滤非叶子区域（过滤包含下级区域的区域）
export function filterNotLeafRegion(regions) {
  let removedRegions = []
  for (let i = 0; i < regions.length; ++i) {
    let childRegionCount = 0
    for (let j = 0; j < regions.length; ++j) { // 汇总子区域
      if (regions[j].parentRegionId === regions[i].id) {
        regions[j].realParentRegionId = regions[j].parentRegionId // 备份实际父区域id
        regions[j].parentRegionId = 0
        ++childRegionCount
      }
    }

    if (childRegionCount > 0) {
      removedRegions.push(regions[i])
    }
  }

  removedRegions.forEach(item => { // 删除需过滤的区域
    let index = regions.indexOf(item)
    if (index > -1) {
      regions.splice(index, 1)
    }
  })
}

// 过滤单子区域（过滤只有包含一个子区域的区域）
export function filterSingleChildRegion(regions) {
  let removedRegions = []
  for (let i = 0; i < regions.length; ++i) {
    let childRegions = []
    for (let j = 0; j < regions.length; ++j) { // 汇总子区域
      if (regions[j].parentRegionId === regions[i].id) {
        childRegions.push(regions[j])
        if (childRegions.length > 1) {
          break
        }
      }
    }

    if (childRegions.length === 1) { // 子区域数量为1，过滤该区域
      childRegions[0].realParentRegionId = childRegions[0].parentRegionId // 备份实际父区域id
      childRegions[0].parentRegionId = regions[i].parentRegionId
      removedRegions.push(regions[i])
    }
  }

  removedRegions.forEach(item => { // 删除需过滤的区域
    let index = regions.indexOf(item)
    if (index > -1) {
      regions.splice(index, 1)
    }
  })
}

//
export function getRegionList(filterMode, callback) {
  if (data.regions.length) {
    if (callback) {
      callback()
    }
    return
  }

  let filter = null
  if (filterMode === 2) { // 过滤非叶子区域
    filter = filterNotLeafRegion
  } else if (filterMode === 1) { // 过滤单子区域的区域
    filter = filterSingleChildRegion
  }

  let params = {
    regionId: 0,
    parentRegionId: 0,
    regionKind: 0,
    pageNum: 1,
    pageSize: 100,
    totalPage: 0
  }
  getDataList(apiInterface.regionList, params, data.regions, filter, callback)
}

// 获取监控设备列表
export function getEncoderList(callback) {
  if (data.encoders.length) {
    if (callback) {
      callback()
    }
    return
  }

  let params = {
    projectId: 0,
    regionId: 0,
    pageNum: 1,
    pageSize: 100,
    totalPage: 0
  }
  getDataList(apiInterface.encoderList, params, data.encoders, null, callback)
}

// 获取监控子设备列表
export function getAuxMonitoringDeviceList(callback) {
  if (data.auxMonitoringDevices.length) {
    if (callback) {
      callback()
    }
    return
  }

  let params = {
    regionId: 0,
    descendantRegionRequired: 1,
    pageNum: 1,
    pageSize: 100,
    totalPage: 0
  }
  getDataList(apiInterface.auxMonitoringDeviceList, params, data.auxMonitoringDevices, null, callback)
}

// 获取服务器列表
export function getServerList(callback) {
  if (data.servers.length) {
    if (callback) {
      callback()
    }
    return
  }

  let params = {
    pageNum: 1,
    pageSize: 100,
    totalPage: 0
  }
  getDataList(apiInterface.serverList, params, data.servers, null, callback)
}

// 获取服务列表
export function getServiceList(callback) {
  if (data.services.length) {
    if (callback) {
      callback()
    }
    return
  }

  let params = {
    pageNum: 1,
    pageSize: 100,
    totalPage: 0
  }
  getDataList(apiInterface.serviceList, params, data.services, null, callback)
}

// 获取地图列表
export function getMapList(callback) {
  if (data.maps.length) {
    if (callback) {
      callback()
    }
    return
  }

  let params = {
    mapId: 0,
    imageUrlRequired: 1,
    pageNum: 1,
    pageSize: 100
  }
  getDataList(apiInterface.mapList, params, data.maps, null, callback)
}

// 获取地图节点模型列表
export function getMapNodeModelList(callback) {
  if (data.mapNodeModels.length) {
    if (callback) {
      callback()
    }
    return
  }

  let params = {
    mapNodeModelId: 0,
    imageUrlRequired: 1,
    pageNum: 1,
    pageSize: 100
  }
  getDataList(apiInterface.mapNodeModelList, params, data.mapNodeModels, null, callback)
}

// 获取运行时刻表数组
export function getRunScheduleList(callback) {
  if (data.runSchedules.length) {
    if (callback) {
      callback()
    }
    return
  }

  if (callback) {
    callback()
  }

/*  let params = {
    pageNum: 1,
    pageSize: 100,
    totalPage: 0
  }
  getDataList(apiInterface.runScheduleList, params, data.runSchedules, null, callback) */
}

// 获取项目列表
export function getProjectList(callback) {
  if (data.projects.length) {
    if (callback) {
      callback()
    }
    return
  }

  let params = {
    pageNum: 1,
    pageSize: 100,
    totalPage: 0
  }
  getDataList(apiInterface.projectList, params, data.projects, null, callback)
}

// 获取部门列表
export function getDepartmentList(callback) {
  if (data.departments.length) {
    if (callback) {
      callback()
    }
    return
  }

  let params = {
    pageNum: 1,
    pageSize: 100,
    totalPage: 0
  }
  getDataList(apiInterface.departmentList, params, data.departments, null, callback)
}

// 获取人员列表
export function getPersonList(callback) {
  if (data.persons.length) {
    if (callback) {
      callback()
    }
    return
  }

  let params = {
    pageNum: 1,
    pageSize: 100,
    totalPage: 0
  }
  getDataList(apiInterface.personList, params, data.persons, null, callback)
}

// 获取用户列表
export function getUserList(callback) {
  if (data.users.length) {
    if (callback) {
      callback()
    }
    return
  }

  let params = {
    userId: 0,
    pageNum: 1,
    pageSize: 100,
    totalPage: 0
  }
  getDataList(apiInterface.userList, params, data.users, null, callback)
}

// 获取系统菜单列表
export function getSystemMenuList(callback) {
  if (data.systemMenus.length) {
    if (callback) {
      callback()
    }
    return
  }

  let params = {
    menuId: 0,
    parentMenuId: 0,
    pageNum: 1,
    pageSize: 100,
    totalPage: 0
  }
  getDataList(apiInterface.systemMenuList, params, data.systemMenus, null, callback)
}

// 获取系统设定列表
export function getSystemSettingList(callback) {
  if (data.systemSettings.length) {
    if (callback) {
      callback()
    }
    return
  }

  let params = {
    id: 0,
    pageNum: 1,
    pageSize: 100,
    totalPage: 0
  }
  getDataList(apiInterface.systemSettingList, params, data.systemSettings, null, callback)
}



// WEBPACK FOOTER //
// ./src/api/get-data.js